import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserService } from '@core/services';
import { CASE_LIBRARY_SEARCH_CHAT_ID, PromptExample } from '@shared/models';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

export const CREATE_VIDEO_CUT_PROMPT_TITLE = 'Create a key takeaways video';

@Injectable({
  providedIn: 'root',
})
export class PromptExempleService {
  private readonly userService = inject(UserService);
  private readonly http: HttpClient = inject(HttpClient);

  promptExemples(chatId: string): Observable<PromptExample[]> {
    return this.http
      .get<PromptExample[]>(`${environment.apiUrl}/v1/prompt-examples/${chatId}`)
      .pipe(
        map((responsePrompts) => {
          let prompts = responsePrompts;
          if (prompts.length === 0) {
            prompts = this.getPromptExemples(chatId);
          }
          return prompts;
        }),
        catchError(() => of(this.getPromptExemples(chatId))),
      );
  }

  private getPromptExemples(chatId: string) {
    return chatId === CASE_LIBRARY_SEARCH_CHAT_ID
      ? this.getCaseLibraryPromptExamples()
      : this.userService.isGuest()
        ? this.getGuestCaseDetailsPromptExamples()
        : this.getUserCaseDetailsPromptExamples();
  }

  private getCaseLibraryPromptExamples(): PromptExample[] {
    return [
      {
        title: 'Show me cases with a complication and how it was managed.',
        prompt: 'Show me cases with a complication and how it was managed.',
        icon: 'search',
        order: 1,
      },
      {
        title: 'Find cases where new findings led to a change in the planned procedure.',
        prompt: 'Find cases where new findings led to a change in the planned procedure.',
        icon: 'takeaways',
        order: 2,
      },
      {
        title: 'Compare the approaches used in similar cases and highlight the main differences.',
        prompt: 'Compare the approaches used in similar cases and highlight the main differences.',
        icon: 'strategy',
        order: 3,
      },
    ];
  }

  private getGuestCaseDetailsPromptExamples(): PromptExample[] {
    return [
      {
        title: 'Create a quiz',
        prompt: 'Create a quiz',
        icon: 'quiz',
        order: 2,
      },
      {
        title: 'Summarize key takeaways',
        prompt: 'Summarize key takeaways',
        icon: 'takeaways',
        order: 3,
      },
      {
        title: 'Explain the procedural approach',
        prompt: 'Explain the procedural approach',
        icon: 'strategy',
        order: 4,
      },
      {
        title: 'Identify key decisions',
        prompt: 'Identify key decisions',
        icon: 'decision-point',
        order: 5,
      },
    ];
  }

  private getUserCaseDetailsPromptExamples(): PromptExample[] {
    return [
      {
        title: CREATE_VIDEO_CUT_PROMPT_TITLE,
        prompt: CREATE_VIDEO_CUT_PROMPT_TITLE,
        icon: 'cut',
        order: 1,
      },
      ...this.getGuestCaseDetailsPromptExamples(),
    ];
  }
}
